import { render } from "./DateRangeSetupEditing.vue?vue&type=template&id=6d1f67fd&ts=true"
import script from "./DateRangeSetupEditing.vue?vue&type=script&lang=ts"
export * from "./DateRangeSetupEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__